var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"id":"rutube-player","width":_vm.width,"height":_vm.height,"src":_vm.sourceUrl,"frameborder":_vm.frameborder,"webkitAllowFullScreen":"","mozallowfullscreen":"","allowFullScreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }